// vim: sts=2:ts=2:sw=2
/*jslint browser: true*/

(function(){
  /* originally from http://www.mailtoencoder.com/ */
  /* web/factsigner/mailtoencode.py */

  function contact (elm){
    // 'mailto:ulf.bartel@berlincode.com'
    const eevolll = ['@', 'l', 'l', ':', '.', 't', 'e', 'n', 'b', 'l', 'o', 'd', 'u', 'e', 'e', 'l', 'r', 'c', 'c', 'o', 't', 'f', 'i', 'a', 'o', 'm', 'r', '.', 'a', 'b', 'i', 'm'];
    const cmycbvm = [17, 3, 16, 6, 10, 14, 19, 23, 18, 8, 30, 26, 7, 27, 15, 21, 20, 29, 24, 25, 4, 9, 22, 12, 5, 31, 13, 28, 1, 11, 2, 0];

    let zsrsmxw= [];
    let content = '';
    let i;
    for(i=0;i<cmycbvm.length;i++){zsrsmxw[cmycbvm[i]] = eevolll[i]; }
    for(i=0;i<zsrsmxw.length;i++){
      content += zsrsmxw[i];
    }

    const anchor = document.createElement('a');
    anchor.classList.add('mail');
    anchor.href=content;
    anchor.appendChild(document.createTextNode(content.substr(7)));

    elm.append(anchor);
  }

  Array.from(document.getElementsByClassName('.contact_berlincode')).forEach((elm) => {
    contact(elm);
  });
})();

